import LinearProgress, {linearProgressClasses} from "@mui/material/LinearProgress";
import {styled} from "@mui/material/styles";
import * as React from "react";
import {Colors, Container} from "../../../ui";

interface ILinearProgress {
  backgroundcolor?: string;
  barcolor?: string;
}

interface IProgressBar extends ILinearProgress {
  value: number;
}

const BorderLinearProgress = styled(LinearProgress)<ILinearProgress>(({backgroundcolor, barcolor, theme}) => {
  return {
    height: 4,
    borderRadius: 2,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: barcolor,
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 2,
      backgroundColor: backgroundcolor,
    },
  };
});

export const ProgressBar = ({value, backgroundcolor, barcolor = Colors.grey._200}: IProgressBar) => {
  return (
    <Container fullWidth>
      <BorderLinearProgress
        variant="determinate"
        value={value}
        backgroundcolor={backgroundcolor}
        barcolor={barcolor}
        sx={{width: "100%"}}
      />
    </Container>
  );
};
